import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2) || 'fr';

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  };

  const langs = [
    { code: 'fr', label: 'FR' },
    { code: 'en', label: 'EN' },
    { code: 'ar', label: 'AR' },
  ];

  return (
    <div className="lang-switcher">
      {langs.map(l => (
        <button
          key={l.code}
          className={`lang-btn${current === l.code ? ' lang-btn--active' : ''}`}
          onClick={() => changeLanguage(l.code)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
